module.exports = __webpack_public_path__ + "img/fj.065f8622.svg";